<div class="placeholder-container">
  {{ placeholderText }}
</div>
